
import Footer from '../component/footer';

const cdnURL = process.env.REACT_APP_CDN_URL;

const ScamAlert = () =>  {
    return ( 
        <div className='ScamAlert-page'>
            <div style={{padding:"30px 0"}}>
                <img src={`${cdnURL}/images/scamalert/ScamAlert-001.jpg`} style={{width:"100%"}}/>
                <img src={`${cdnURL}/images/scamalert/ScamAlert-002.jpg`} style={{width:"100%"}}/>
                <img src={`${cdnURL}/images/scamalert/ScamAlert-003.jpg`} style={{width:"100%"}}/>
                <img src={`${cdnURL}/images/scamalert/ScamAlert-004.jpg`} style={{width:"100%"}}/>
                <img src={`${cdnURL}/images/scamalert/ScamAlert-005.jpg`} style={{width:"100%"}}/>
                <img src={`${cdnURL}/images/scamalert/ScamAlert-006.jpg`} style={{width:"100%"}}/>
                <img src={`${cdnURL}/images/scamalert/ScamAlert-007.jpg`} style={{width:"100%"}}/>
                <img src={`${cdnURL}/images/scamalert/ScamAlert-008.jpg`} style={{width:"100%"}}/>
                <img src={`${cdnURL}/images/scamalert/ScamAlert-009.jpg`} style={{width:"100%"}}/>
            </div>
            
            <div style={{padding:"0px 5.208vw"}}>
                <Footer />
            </div>
        </div>
    );
};

export default ScamAlert;